/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Scene_Change_Detection_Thumbnail_Prompt_YesInputs */



/**
* | output |
* | --- |
* | "Yes, generate" |
*
* @param {Scene_Change_Detection_Thumbnail_Prompt_YesInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const scene_change_detection_thumbnail_prompt_yes = /** @type {((inputs?: Scene_Change_Detection_Thumbnail_Prompt_YesInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Scene_Change_Detection_Thumbnail_Prompt_YesInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Oui, générer")
	if (locale === "de") return /** @type {LocalizedString} */ ("Ja, generieren")
	if (locale === "it") return /** @type {LocalizedString} */ ("Sì, genera")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Да, генерировать")
	if (locale === "es") return /** @type {LocalizedString} */ ("Sí, generar")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("是的，生成")
	if (locale === "ja") return /** @type {LocalizedString} */ ("はい、生成します")
	if (locale === "hi") return /** @type {LocalizedString} */ ("हाँ, उत्पन्न करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Sim, gerar")
	return /** @type {LocalizedString} */ ("Yes, generate")
});